import { TNewSectionColors } from 'src/app/products/app-solutions/topic-apps/topic-apps.interface';
import { ICTA } from '../cta/cta.interface';
import { IDescriptionListItemContent } from '../description-list-item/description-list-item.interface';

export enum EButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIATY = 'tertiary',
  TEXT_ONLY = 'text-only',
  TEXT_ONLY_WHITE = 'text-only-white',
  LINK_PRIMARY = 'link-primary',
  LINK_SECONDARY = 'link-secondary',
}

export enum EButtonSize {
  REGULAR = 'regular',
  MEDIUM = 'medium',
  SMALL = 'small',
  TINY = 'tiny',
}

export enum ESectionColor {
  BLUE = 'blue',
  RED = 'red',
  GRAY = 'gray',
  YELLOW = 'yellow',
  PURPLE = 'purple',
  ORANGE = 'orange',
  WHITE_BLUE = 'white-blue',
  WHITE_RED = 'white-red',
  WHITE_YELLOW = 'white-yellow',
  WHITE_PURPLE = 'white-purple',
  WHITE_ORANGE = 'white-orange',
  LIGHT_RED = 'light-red',
  LIGHT_BLUE = 'light-blue',
  LIGHT_YELLOW = 'light-yellow',
  LIGHT_PURPLE = 'light-purple',
  LIGHT_ORANGE = 'light-orange',
  GRAY_BLUE = 'gray-blue',
  GRAY_RED = 'gray-red',
  GRAY_PURPLE = 'gray-purple',
  GRAY_ORANGE = 'gray-orange',
  DARK_BLUE = 'dark-blue',
  DARK_BLUE_RED = 'dark-blue-red',
  DARK_LIGHT_BLUE_RED = 'dark-light-blue-red',
}

export enum ESectionCTAPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum EIcons {
  CALENDAR_FAVOURITE_1 = 'calendar-favorite-1',
  LOGIN_KEY = 'login-key',
  DISABILITY_WHEELCHAIR = 'disability-wheelchair',
  APP = 'app',
  ARROW_BACKWARD = 'arrow-backward',
  ARROW_FORWARD = 'arrow-forward',
  AUTHORING_TOOL_LOGO = 'authoring-tool-logo',
  BOOK_LIBRARY_2 = 'book-library-2',
  BOOK_OPEN_2 = 'book-open-2',
  BOOK_STAR_1 = 'book-star-1',
  BOOKMARK_STROKE = 'bookmark-stroke',
  BUTTON_PLAY = 'button-play',
  CALENDAR_FAVOURITE = 'calendar-favorite',
  CALENDARS = 'calendars',
  CHAT_TRANSLATE = 'chat-translate',
  CHECK_CIRCLE = 'check-circle',
  CHECK_SHIELD = 'check-shield',
  CLOSE = 'close',
  CLOUD_DATA_TRANSFER = 'cloud-data-transfer',
  CODE = 'code',
  COMMON_FILE_MULTIPLE = 'common-file-multiple',
  COMMON_FILE_QUILL = 'common-file-quill',
  CONTENT_BROWSER_EDIT = 'content-browser-edit',
  DESIGN_TOOL_PEN = 'design-tool-pen',
  DESK_GUIDES = 'desk-guides',
  DISCOUNT_DOLLAR_DASH = 'discount-dollar-dash',
  EARTH_1 = 'earth-1',
  EARTH_LOCATE = 'earth-locate',
  EMAIL_ACTION_UNREAD = 'email-action-unread',
  FOLDERS = 'folders',
  GAUGE_DASHBOARD_1 = 'gauge-dashboard-1',
  HAMBURGER = 'hamburger',
  HREF_ARROW_RIGHT = 'href-arrow-right',
  HYPERLINK_3 = 'hyperlink-3',
  KEY_LOCK = 'key-lock',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LAYOUT_MODULE_1 = 'layout-module-1',
  LIGHT_BULB_SHINE = 'light-bulb-shine',
  LIST_BULLETS = 'list-bullets',
  LIST_BULLETS_LARGE = 'list-bullets-large',
  LOCK_1 = 'lock-1',
  LOCK_SHIELD = 'lock-shield',
  LOGIN_KEY_1 = 'login-key-1',
  LOVE_SHIELD = 'love-shield',
  MAGNETS = 'magnets',
  MARKETING_CARD = 'marketing-card',
  MAPS_MARK = 'maps-mark',
  MAPS_PIN_1 = 'maps-pin-1',
  MEETING_CAMERA = 'meeting-camera',
  MEETING_HEADPHONES = 'meeting-headphones',
  MEGAPHONE = 'megaphone',
  MESSAGES_BUBBLE_SQUARE_MENU = 'messages-bubble-square-menu',
  MESSAGES_PEOPLE_USER_QUESTION = 'messages-people-user-question',
  MESSAGES_PEOPLE_USER_WARNING_1 = 'messages-people-user-warning-1',
  MULTIPLE_USERS_1 = 'multiple-users-1',
  NETWORK_NAVIGATION = 'network-navigation',
  NEWSPAPER = 'newspaper',
  NEWSPAPER_FOLD = 'newspaper-fold',
  OFFICE_FILE_PDF_1 = 'office-file-pdf-1',
  OFFICE_FILE_TEXT = 'office-file-text',
  PAMPHLETS = 'pamphlets',
  PHONE = 'phone',
  PHONE_ACTION_CODE = 'phone-action-code',
  PHONE_ACTIONS_FORWARD_1 = 'phone-actions-forward-1',
  PHONE_HAND_HOLD_1 = 'phone-hand-hold-1',
  PIN_LOCATION_2 = 'pin-location-2',
  POCKET_CARDS = 'pocket-cards',
  POCKET_GUIDES = 'pocket-guides',
  POSTERS = 'posters',
  PRESENTATION_ANALYTICS = 'presentation-analytics',
  QUESTION_HELP_MESSAGE = 'question-help-message',
  QUILL_WRITE = 'quill-write',
  RANKING_WINNER_MEDAL = 'ranking-winner-medal',
  SAVING_PIGGY_DOLLARS = 'saving-piggy-dollars',
  SHIELD_LOCK = 'shield-lock',
  SHIELD_WARNING = 'shield-warning',
  SOCIAL_PROFILE_NETWORK = 'social-profile-network',
  TAGS_DOUBLE_1 = 'tags-double-1',
  TARGET_CORRECT = 'target-correct',
  TASK_LIST_EDIT_1 = 'task-list-edit-1',
  TASK_LIST_PEN = 'task-list-pen',
  TASK_LIST_SEARCH = 'task-list-search',
  TEAM_MEETING = 'team-meeting',
  TEAM_SHARE_IDEA = 'team-share-idea',
  UNIVERSAL_ACCESS = 'universal-access',
  USER_NETWORK = 'user-network',
  USER_QUESTION = 'user-question',
  VIDEO_PLAYER_SMARTPHONE_HORIZONTAL = 'video-player-smartphone-horizontal',
  WALLET_CARDS = 'wallet-cards',
  WIFI_SIGNAL_2 = 'wifi-signal-2',
}

export interface IBullet {
  icon: EIcons;
  title: string;
  description: string;
}

export interface ICTAdeprecated {
  label: string;
  routerLink?: string;
  href?: string;
  color?: EButtonColors;
  size?: EButtonSize;
  download?: boolean;
  icon?: EIcons;
  fragment?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: 'nofollow';
}

export interface IImage {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  caption?: string;
}

export interface IVideo {
  src: string;
  title: string;
}

export interface IAppIcons {
  image: IImage;
  routerLink: string;
}

export interface ISection {
  id?: number;
  __component?: ESectionType;
  witty?: string;
  title?: string;
  description?: string;
  sectionColor: ISectionColor;
  ctas?: ICTA[];
}

export interface IDescriptionListSection extends ISection {
  list: IDescriptionListItemContent[];
}

export interface ISectionColor {
  id?: number;
  color: ESectionColor | TNewSectionColors;
}

export interface IBullet {
  id?: number;
  title: string;
  description: string;
  icon: EIcons;
}

export enum ESectionType {
  HERO_SECTION = 'sections.hero-section',
  SUB_HERO_SECTION = 'sections.sub-hero-section',
  DESCRIPTION_LIST_SECTION = 'sections.description-list-section',
  BOTTOM_IMAGE_SECTION = 'sections.bottom-image-section',
}
